import View, { AppFooterProps as _AppFooterProps} from "./app-footer-view";
import {useCallback, useEffect, useState} from "react";

export interface AppFooterProps extends Omit<_AppFooterProps, "footerRef"|"variant"|"isSticky"> {}
function AppFooter(props: AppFooterProps) {
  const [footerVariant, setFooterVariant] =
      useState<_AppFooterProps["variant"]>("light");
  const [footer, setFooter] = useState<HTMLElement|undefined|null>(undefined)
  const footerRef = useCallback((node: HTMLElement) => {
    setFooter(node);
  }, []);
  useEffect(() => {
    if (footer) {
      const cstyle = getComputedStyle(footer);
      const variant = cstyle.getPropertyValue('--duke-footer-bs-theme');
      setFooterVariant(variant);
    }
  }, [footer]);
  return <View
      {...props}
      footerRef={footerRef}
      variant={footerVariant}
  />;
}
export default AppFooter;
